import { skills as allSkills, tools as allTools } from "../../content";
import { useLocalize } from "../../content/useLocalize";
import type { SkillId, ToolId } from "../../types";

export interface LoadoutNames {
  toolName: (id: ToolId) => string;
  skillName: (id: SkillId) => string;
}

/**
 * Localized display names for tools and skills, so in-task hints call a helper
 * by the same name the player saw in the shop or on the skills screen.
 */
export function useLoadoutNames(): LoadoutNames {
  const t = useLocalize();
  return {
    toolName: (id) => {
      const tool = allTools.find((entry) => entry.id === id);
      return tool ? t(tool.name) : id;
    },
    skillName: (id) => {
      const skill = allSkills.find((entry) => entry.id === id);
      return skill ? t(skill.name) : id;
    },
  };
}
